/**
 * SideNavContext.ts — tilstanden SideNavLink og SideNavMenu trenger fra SideNav
 *
 * expanded: menyen er åpen (ellers er den en smal rail med bare ikoner på bred skjerm).
 * expand: åpner menyen; kalles når en dropdown trykkes i rail-modus, siden undermenyen ikke får plass i en rail.
 */

import { createContext } from 'react';

export interface SideNavState {
  expanded: boolean;
  expand?: () => void;
}

export const SideNavContext = createContext<SideNavState>({ expanded: true });
